import { useQuery } from '@tanstack/react-query';
import { get } from '../api/client.js';

export function useJhaSubmissions({ from, to, user }) {
  const params = new URLSearchParams({ from: String(from), to: String(to) });
  if (user) params.set('user', user);
  return useQuery({
    queryKey: ['admin', 'jha-submissions', from, to, user || 'all'],
    queryFn: () => get(`/api/admin/jha/submissions?${params.toString()}`),
    enabled: !!from && !!to,
    staleTime: 30_000,
  });
}

export function useJhaSubmission(id) {
  return useQuery({
    queryKey: ['admin', 'jha-submissions', id],
    queryFn: () => get(`/api/admin/jha/submissions/${id}`),
    enabled: !!id,
  });
}
